import React from 'react';
import { Filter, TextInput, List, Datagrid, TextField, BooleanField } from 'react-admin';
import ScreenDescription from '../ScreenDescription';

const FilterByName = (props) => (
  <Filter {...props}>
    <TextInput label="Buscar" source="name" alwaysOn />
  </Filter>
);

const MessageTypeList = props => (
  <>
    <ScreenDescription>
      Tipos representam a <strong>categoria de cobrança da Meta</strong> (marketing, utilidade, autenticação, serviço, janela livre).
      Cada tipo tem um custo unitário com histórico por data de vigência — editar o custo (dentro de cada tipo) nunca reescreve o
      que já foi cobrado no passado, só passa a valer a partir da data escolhida.
    </ScreenDescription>
    <List
      {...props}
      filters={<FilterByName />}
      sort={{ field: 'name', order: 'ASC' }}
      bulkActionButtons={false}
    >
      <Datagrid rowClick="edit">
        <TextField source="name" label="Nome" />
        <TextField source="key" label="Chave" />
        <BooleanField source="active" label="Ativo" />
      </Datagrid>
    </List>
  </>
);

export default MessageTypeList;
